import { createFileRoute } from '@tanstack/react-router';
import { ServiceRecordsPage } from '@/features/payouts/pages/service-records-page';

export const Route = createFileRoute('/_app/service-records')({ component: ServiceRecordsPage });
